import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})
export class FieldMappingService {

  apiBaseURL!: string;
  constructor(environmentService: EnvironmentService,
    private readonly http: HttpClient
  ) {
    this.apiBaseURL = environmentService.getApiEndpoint()
  }


  createFieldMapping(formData: any): Observable<any> {
    return this.http.post<any>(this.apiBaseURL + 'tna/field-mapping', formData)
  }
  updateFieldMapping(formData: any, id: any): Observable<any> {
    return this.http.put<any>(this.apiBaseURL + 'tna/field-mapping/' + id, formData)
  }
  getFieldMappingDataById(id: any): Observable<any> {
    return this.http.get<any>(this.apiBaseURL + 'tna/field-mapping/' + id)
  }
  getFieldMappingListWithPagi(params: {}): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params })
    }
    return this.http.get<any>(this.apiBaseURL + 'tna/field-mapping', options)
  }

  getStagingAudit(params: {}): Observable<any> {
    const options = { params: new HttpParams({ fromObject: params }) };
    return this.http.get<any>(this.apiBaseURL + 'tna/authorisation/staging-audit', options);
  }
}
